import React from "react";
import { navigate } from "src/utils/react-utils";

export default function SolidityWizardHeader() {

    const goToMyReview = () => {
        navigate('/my-reviews');
    }

    return (
        <>
            <div css={`
                width: 100%;
            `}>
                <div css={`
                    font-size:24px;
                    color:#2E2E38;
                `}>
                    Smart Contract Review Wizard
                </div>                
            </div>
        </>
    )
}
